<template>
  <a-modal
    class="data-item-dialog"
    title="数据预览"
    width="800px"
    v-model:visible="visible"
    :footer="false"
  >
    <a-carousel ref="slider" arrows>
      <template #prevArrow>
        <div class="custom-slick-arrow" style="left: 10px;zIndex: 1">
          <left-circle-outlined />
        </div>
      </template>
      <template #nextArrow>
        <div class="custom-slick-arrow" style="right: 10px">
          <right-circle-outlined />
        </div>
      </template>
      <img class="large-pic"
        v-for="item in list"
        :key="item.id"
        :src="appConfig.baseImgUrl + item.url"
        alt="数据图片">
    </a-carousel>
  </a-modal>
</template>
<script>
import { mapState } from 'vuex'
import { LeftCircleOutlined, RightCircleOutlined } from '@ant-design/icons-vue'
export default {
  components: {
    LeftCircleOutlined,
    RightCircleOutlined
  },
  props: {
    list: {
      type: Array,
      default: () => []
    },
    defaultId: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      visible: false
    }
  },
  computed: {
    ...mapState(['appConfig'])
  },
  methods: {
    open () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.slider.goTo(this.defaultId)
      })
    }
  }
}
</script>
<style lang="less" scoped>
.data-item-dialog {
  .large-pic {
    width: 100%; min-height: 300px;
    background: #ccc;
  }
  .ant-carousel ::v-deep(.slick-arrow.custom-slick-arrow) {
    width: 25px;
    height: 25px;
    font-size: 25px;
    color: #fff;
    background-color: rgba(31, 45, 61, 0.11);
    opacity: 0.3;
  }
  .ant-carousel ::v-deep(.custom-slick-arrow:before) {
    display: none;
  }
  .ant-carousel ::v-deep(.custom-slick-arrow:hover) {
    opacity: 0.5;
  }
}
</style>
